'use strict';

angular.module('app.influencerGroupCondition', [])

.controller('influencerGroupConditionCtrl', ['$scope', '$rootScope', '$http', '$compile', '$modal', 'influencerGroupConditionService', function ($scope, $rootScope, $http, $compile, $modal, influencerGroupConditionService) {

    var definitions = angular.copy($rootScope.definitions);
    $scope.conditionOperators = [];
    $scope.conditionTypes = [];
    $scope.conditionComparisons = [];
    $scope.conditionComparisonValues = [];
    $scope.countries = [];
    angular.forEach(definitions.countries, function(country) {
        if(country.isActive == 1) {
            $scope.countries.push(country);
        }
    })

    $scope.minImpactList = [
        {id: 2, name: 25},
        {id: 1, name: 50},
        {id: 2, name: 75},
        {id: 2, name: 100},
        {id: 2, name: 125},
        {id: 2, name: 150},
        {id: 2, name: 175},
        {id: 2, name: 200}
    ];

    $scope.minEngagementList = [
        {id: 2, name: 5000},
        {id: 1, name: 10000},
        {id: 2, name: 15000},
        {id: 2, name: 20000},
        {id: 2, name: 25000},
        {id: 2, name: 50000},
        {id: 2, name: 75000},
        {id: 2, name: 100000}
    ];

    $scope.minReachList = [
        {id: 2, name: 5000},
        {id: 1, name: 10000},
        {id: 2, name: 15000},
        {id: 2, name: 20000},
        {id: 2, name: 25000},
        {id: 2, name: 50000},
        {id: 2, name: 75000},
        {id: 2, name: 100000}
    ];

    influencerGroupConditionService.getInfluencerGroupConditionOperators(false)
    .then(function(responseInfluencerGroupConditionOperators) {
        $scope.conditionOperators = responseInfluencerGroupConditionOperators.data;
        if($scope.conditionItem.selectedConditionOperator != null) {
            $scope.conditionOperators.forEach(function(item) {
                if(item.description == $scope.conditionItem.selectedConditionOperator) {
                    item.ticked = true;
                }
            });
        } else {
            $scope.conditionOperators[0].ticked = true; 
            $scope.selectConditionOperator($scope.conditionOperators[0].description);
        }

        influencerGroupConditionService.getInfluencerGroupConditionTypes(false)
        .then(function(responseInfluencerGroupConditionTypes) {
            $scope.conditionTypes = responseInfluencerGroupConditionTypes.data;
            if($scope.conditionItem.selectedConditionType != null) {
                $scope.conditionTypes.forEach(function(item) {
                    if(item.description == $scope.conditionItem.selectedConditionType) {
                        item.ticked = true;
                    }
                });

                $scope.loadNotificationComparisons(false);
            } else {
                $scope.conditionOperators[0].ticked = true;    
            }
        }) 
    })
   
    $scope.unexistingClick = function(tagToDefine, $event) {
        var unexistingMention = $event.target;
        var typeid = null;
        var tagElement = unexistingMention.parentElement;
        var DomainPatter = new RegExp(/^(?!:\/\/)([a-zA-Z0-9]+\.)?[a-zA-Z0-9-]+\.([a-zA-Z]{2,6}|[a-zA-Z]{2,6}.[a-zA-Z]{2,6})?$/i);
        if(!DomainPatter.test(tagToDefine) && tagToDefine.indexOf("#") != 0){
          typeid = 1;
        } else if(DomainPatter.test(tagToDefine) && tagToDefine.indexOf("#") != 0){
          typeid = 2;
        } else if(!DomainPatter.test(tagToDefine) && tagToDefine.indexOf("#") == 0){
          typeid = 3;
        }

        $rootScope.newMentionModalHandler(tagToDefine, typeid, -1, function(newMention) { // -1 for global mention
            if(newMention){
                var newSpan = $compile('<span class="txt-waitapprove">+ Wait For Approve&nbsp;</span><img src="/images/question.gif" class="questionMention">')($scope);
                $(tagElement).find('.unexisting').remove();
                $(tagElement).find('.questionMention').remove();
                $(tagElement).append(newSpan);
                $scope.conditionItem.selectedConditionComparisionValue = newMention.keyword;
            } else {
                console.log('cancel');
            }
        });
    }

    $scope.initTagit = function() {
        $scope.element.find("#mentionTagit").tagit({
            allowDuplicates: false,
            allowSpaces: true,
            removeConfirmation: true,
            tagLimit: 1,
            caseSensitive: false,
            autocomplete: ({
                source: function (request, response) {
                    var data = {
                        searchMention: request.term
                    }
                    var req = {
                        url: $rootScope.apiUrl + 'discover/getRelativeMention',
                        method: 'POST',
                        loader: false,
                        data: JSON.stringify(data)
                    }
                    var relativeMention = [];
                    $http(req).success(function (dataResponse){
                        angular.forEach(dataResponse.data, function(item) {
                            var reMention = {
                                label: item.keyword,
                                value: item.keyword
                            };
                            relativeMention.push(reMention);
                        });
                        response(relativeMention);
                    });
                },
                delay: 0,
                minLength: 1
            }),
            // availableTags: availableTags(),

            beforeTagAdded: function (event, ui) {
                if(ui.tagLabel.split(' ').length >= 3)
                {
                    $scope.element.find('.tagit-new').popover({content: '<div class="text-danger" style="width: 200px;word-wrap:break-word;">Keyword is not valid, should input only 1 or 2 words</div>', html: true});
                    $scope.element.find('.tagit-new').popover('show');
                    event.stopPropagation();
                    return false;
                }
                $scope.element.find('.tagit-new').popover('destroy');
            },
            onTagClicked: function (event, ui) {
                
            },
            afterTagAdded: function (event, ui) {
                var isNewTag = false;
                var id = 0;
                var label = encodeURIComponent(ui.tagLabel);

                $scope.element.find(".tagit-new").hide();

                $http.get($rootScope.apiUrl + "mention/existingMentionDiscover?mention=" + label, {loader: false}).
                    success(function (response) {
                        id = response.data.id;
                        if (id == null) {
                            isNewTag = true;
                        } 

                        if(isNewTag){
                            var newMention = $compile('<a class="unexisting" role="button" ng-click="unexistingClick(\'' + ui.tagLabel + '\', $event)">+ New Mention&nbsp;</a><img src="/images/question.gif" class="questionMention">')($scope);
                            ui.tag.append(newMention);
                        } else {
                            $scope.conditionItem.selectedConditionComparisionValue = response.data.keyword;
                            ui.tag.children(".tagit-label").get(0).text = response.data.keyword;
                            if(response.data.approved == 2){
                                var newMention = $compile('<span class="txt-waitapprove">+ Wait For Approve&nbsp;</span><img src="/images/question.gif" class="questionMention">')($scope);
                                ui.tag.append(newMention);
                            }
                        }

                    }).error(function (response) {
                        alert("We cannot get info about this keyword, please try again...")
                        console.log(response.data);
                    });
            },
            beforeTagRemoved: function(event, ui) {
                
            },
            afterTagRemoved: function (event, ui) {
                $scope.conditionItem.selectedConditionComparisionValue = "";
                $scope.element.find(".tagit-new").show();
            }

        }); 

        if($scope.conditionItem.selectedConditionComparisionValue) {
            $scope.element.find("#mentionTagit").tagit("createTag", $scope.conditionItem.selectedConditionComparisionValue); 
        }
    }

    $scope.selectConditionOperator = function(conditionOperator) {
        if ($scope.conditionItem.selectedConditionType === "country" && conditionOperator === "AND") {
            var countryListCount = 0;
            for (var i=0; i<$scope.conditionListObject.length; i++) {
                if ($scope.conditionListObject[i].selectedConditionType === "country") {
                    countryListCount++;
                }
            }
            if (countryListCount > 1) {
                $scope.conditionOperators[0].ticked = false; 
                $scope.conditionOperators[1].ticked = true; 
                var errorModalInstance = $modal.open({
                    scope: $scope,
                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                    windowClass: 'modal-dialog-mention-error'
                });
                $scope.errorModalInstance = errorModalInstance;
                $scope.errorMessage = "You can't mix Match Any and Match All conditions for countries.";
                return;
            }
            
        }
        $scope.conditionItem.selectedConditionOperator = conditionOperator;
    }

    $scope.selectConditionType = function(conditionType) {
        var differentMatch = false;
        var isAllowedMultiCountry = true;
        if (conditionType === "country") {
            for (var i=0; i<$scope.conditionListObject.length; i++) {
                if ($scope.conditionListObject[i].selectedConditionType === "country" && $scope.conditionListObject[i].selectedConditionOperator === "AND") {
                    isAllowedMultiCountry = false;
                    break;
                }
                if (i === ($scope.conditionListObject.length - 1) && $scope.conditionListObject[i].selectedConditionOperator === "AND") {
                    isAllowedMultiCountry = false;
                }
            }
        }

        if(conditionType !== "keyword" ) {
            if (conditionType === "country" && isAllowedMultiCountry ) {
            }
            else {
                $scope.conditionListObject.forEach(function(conditionObject) {
                    if(conditionObject.index != $scope.conditionItem.index && conditionObject.selectedConditionType == conditionType) {
                        differentMatch = true;
                    }                
                })
            }
        }

        if(differentMatch){
            $scope.conditionTypes.forEach(function(item){
                item.ticked = false;
            })

            var errorModalInstance = $modal.open({
                scope: $scope,
                templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                windowClass: 'modal-dialog-mention-error'
            });
            $scope.errorModalInstance = errorModalInstance;
            if (conditionType === "country") {
                var isAllTheSameOperator = true;
                for (var n=0; n<$scope.conditionListObject.length; n++) {
                    if ($scope.conditionListObject[n].selectedConditionType === "country" && $scope.conditionListObject[n].selectedConditionOperator !== $scope.conditionItem.selectedConditionOperator) {
                        isAllTheSameOperator = false;
                        break
                    }
                }
                if (isAllTheSameOperator) {
                    $scope.errorMessage = "You can't select multiple Match All conditions for the same field.";
                }
                else {
                    $scope.errorMessage = "You can't mix Match Any and Match All conditions for countries.";
                }
            }
            else {
                $scope.errorMessage = "You already added a condition related to this issue";
            }
        } else {
            $scope.conditionItem.selectedConditionType = conditionType;
            $scope.loadNotificationComparisons(true);
        }
    }

    $scope.loadNotificationComparisons = function(defaultSelect) {
        influencerGroupConditionService.getInfluencerGroupComparisions(false)
        .then(function(response) {
            switch($scope.conditionItem.selectedConditionType) {
                case "country":
                    response.data.splice(2,1);
                    break;
                case "keyword":
                    response.data.splice(2,1);
                    break;
                default:
                    response.data.splice(0,2);
                    break;
            }

            $scope.conditionComparisons = response.data;
            if(defaultSelect) {
                $scope.conditionComparisons[0].ticked = true;
                $scope.selectConditionComparison($scope.conditionComparisons[0].description);
                $scope.conditionItem.selectedConditionComparisionValue = null;
            } else {
                if($scope.conditionItem.selectedConditionComparision != null) {
                    $scope.conditionComparisons.forEach(function(item) {
                        if(item.description == $scope.conditionItem.selectedConditionComparision) {
                            item.ticked = true;
                        }
                    });
                }
            }

            switch($scope.conditionItem.selectedConditionType) {
                case "country":
                    $scope.conditionComparisonValues = $scope.countries;
                    if(defaultSelect) {
                        $scope.conditionComparisonValues[0].ticked = true;
                        $scope.selectConditionComparisonValue($scope.conditionComparisonValues[0].name);
                    } else {
                        if($scope.conditionItem.selectedConditionComparisionValue != null) {
                            $scope.conditionComparisonValues.forEach(function(item) {
                                if(item.name == $scope.conditionItem.selectedConditionComparisionValue) {
                                    item.ticked = true;
                                }
                            });
                        }
                    }
                    break;
                case "reach":
                    $scope.conditionComparisonValues = angular.copy($scope.minReachList);
                    if(defaultSelect) {
                        $scope.conditionComparisonValues[0].ticked = true;
                        $scope.selectConditionComparisonValue($scope.conditionComparisonValues[0].name);
                    } else {
                        if($scope.conditionItem.selectedConditionComparisionValue != null) {
                            $scope.conditionComparisonValues.forEach(function(item) {
                                if(item.name == $scope.conditionItem.selectedConditionComparisionValue) {
                                    item.ticked = true;
                                }
                            });
                        }
                    }

                    break;
                case "engagement":
                    $scope.conditionComparisonValues = angular.copy($scope.minEngagementList);
                    if(defaultSelect) {
                        $scope.conditionComparisonValues[0].ticked = true;
                        $scope.selectConditionComparisonValue($scope.conditionComparisonValues[0].name);
                    } else {
                        if($scope.conditionItem.selectedConditionComparisionValue != null) {
                            $scope.conditionComparisonValues.forEach(function(item) {
                                if(item.name == $scope.conditionItem.selectedConditionComparisionValue) {
                                    item.ticked = true;
                                }
                            });
                        }
                    }
                    break;
                case "impact":
                    $scope.conditionComparisonValues = angular.copy($scope.minImpactList);
                    if(defaultSelect) {
                        $scope.conditionComparisonValues[0].ticked = true;
                        $scope.selectConditionComparisonValue($scope.conditionComparisonValues[0].name);
                    } else {
                        if($scope.conditionItem.selectedConditionComparisionValue != null) {
                            $scope.conditionComparisonValues.forEach(function(item) {
                                if(item.name == $scope.conditionItem.selectedConditionComparisionValue) {
                                    item.ticked = true;
                                }
                            });
                        }
                    }
                    break;
            }
        })
    }

    $scope.selectConditionComparison = function(conditionComparison) {
        // check country rule
        if ($scope.conditionItem.selectedConditionType === "country") {
            var condList = $scope.conditionListObject,
                isAccepted = true;
            for (var i=0; i<condList.length; i++) {
                if (condList[i].index !== $scope.conditionItem.index && condList[i].selectedConditionType === "country" && condList[i].selectedConditionComparision !== conditionComparison) {
                    isAccepted = false;
                    break;
                }
            }

            if (!isAccepted) {
                var errorModalInstance = $modal.open({
                    scope: $scope,
                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                    windowClass: 'modal-dialog-mention-error'
                });
                $scope.errorModalInstance = errorModalInstance;
                $scope.errorMessage = "You can't both include and exclude desired countries. When choosing the Is operator, we'll exclude all but the specified countries.";
                if (conditionComparison === '=') {
                    $scope.conditionComparisons[0].ticked = false;
                    $scope.conditionComparisons[1].ticked = true;
                }
                else {
                    $scope.conditionComparisons[0].ticked = true;
                    $scope.conditionComparisons[1].ticked = false;
                }
                return;
            }
        }

        $scope.conditionItem.selectedConditionComparision = conditionComparison;
    }

    $scope.selectConditionComparisonValue = function(conditionComparisonValue) {
        $scope.conditionItem.selectedConditionComparisionValue = conditionComparisonValue;
    }

    $scope.addCondition = function(){
        var newIndex = $scope.conditionListObject.length;
        $scope.conditionListObject.push({
            index: newIndex,
            selectedConditionOperator: null,
            selectedConditionType: null,
            selectedConditionComparision: null,
            selectedConditionComparisionValue: null
        });
    }

    $scope.removeCondition = function(index) {
        console.log(index)
        console.log($scope.conditionListObject);
        $scope.conditionListObject.splice(index, 1);
    }
}])